module.exports = __webpack_public_path__ + "media/images/application/template/meganav/conversions/workshops-mobile-3efd2f82157d58a28b4aeea9dee5c1cd.png";